var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('aside',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],staticClass:"sidebar",class:{ 'sidebar--is-active': _vm.isActive },on:{"click":_vm.handleClick}},[_c('grid-container',{staticClass:"sidebar__inner"},[_c('div',{staticClass:"sidebar__content"},[_vm._t("default")],2)])],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d360e534","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Navigation/Sidebar.vue
// module id = null
// module chunks = 